module.exports = __webpack_public_path__ + "img/aulasMonstro.34a3e2ba.png";